import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    DesignSystemNavigationModule,
    SIDE_NAV_CONFIGURATOR,
    SideNavConfigurator,
} from '@montebravo.tech/design-system-navigation';
import { of } from 'rxjs';
import { LeftMenuComponent } from './left-menu.component';
import { NAV_LINKS } from './left-menu.component.type';

@NgModule({
    declarations: [LeftMenuComponent],
    imports: [CommonModule, DesignSystemNavigationModule],
    providers: [
        {
            provide: SIDE_NAV_CONFIGURATOR,
            useValue: {
                getNavLinks: () => of(NAV_LINKS),
            } as SideNavConfigurator,
        },
    ],
    exports: [LeftMenuComponent],
})
export class LeftMenuModule {}
